export class Issue {
  Id: number;
  fkProblem?: number;
  SortOrder: number;

  RuleDescription: string;
  IssueName: string;
  Fields: Array<any> = [];
  FieldsJson: string;

  IsActive: boolean;
  IsVoiceBotActive: boolean;
  VoiceBotDescription: string;
  VoiceBotStepsToResolve: string;
  ShowInPage: boolean;
  IsNotify: boolean;
  GateVend: boolean;
  PowerAutomate: boolean;
  PowerAutomateIntegrations?: PowerAutomateIntegration[];
  StartChargingEnabled?: boolean;
  StopChargingEnabled?: boolean;
  MaintenanceModeEnabled?: boolean;
  ResetStationEnabled?: boolean;

  hasIncident: boolean;
  Issue?: Issue | null = null;

  ProblemName?: string;
  RuleSetName?: string;

  fkLot?: number;
  fkIssue?: number;
}


interface PowerAutomateIntegration {
  Code: string;
  Name: string;
}
